<template>
  <div class="calendar-month-list">
    <ol class="list-unstyled">
      <MonthSection
        v-for="(day, index) of $t(`calendar.header.daysOfWeek`)"
        :key="index"
        :day="day"
        :rowType="'weekHeader'"
      />
      <MonthSection
        @click.native="$emit('changeViewToWeek', day)"
        v-for="(day, index) of month"
        :key="index + 7"
        :day="day"
        :activeMonth="new Date(+month[15].date).getMonth()"
      />
    </ol>
  </div>
</template>

<script>
import MonthSection from '@/components/Calendar/MonthSection'

export default {
  props: {
    month: Array,
  },
  components: {
    MonthSection,
  },
}
</script>

<style lang="scss">
.calendar-month-list {
  padding: 0.75rem 0;
  @media (max-width: 576px) {
    padding: 0;
    margin-top: 11px;
  }
}
</style>
